// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__HbKaR","colMin":"styles_colMin__y-8sI","colCheckbox":"styles_colCheckbox__1mJPJ"};